<template>
  <div id="app">
    <top-header></top-header>
    <div class="main-container"><router-view /></div>
    <app-footer></app-footer>
  </div>
</template>

<script>
import TopHeader from "@/components/TopHeader.vue";
import AppFooter from "@/components/AppFooter.vue";
export default {
  components: {
    "top-header": TopHeader,
    "app-footer": AppFooter
  }
};
</script>

<style lang="scss">
body {
  background: #ffffff;
  font-weight: normal;
  font-size: 16px;
  line-height: 1.625;
  // font-family: "Quicksand", sans-serif;
  font-family: "Century Gothic";
}
.scaffold {
  background: #ffffff;
}
.clickable {
  cursor: pointer;
}
.childs {
  text-align: center;
}
.list-unstyled {
  list-style: none;
  margin: 20px 0;
}
.main-container {
  min-height: 900px;
  margin: 70px 0 0 0;
}
.card {
  background: #fff !important;
  border-radius: 2px !important;
  display: inline-block !important;
  // height: 300px !important;
  // margin: 1rem !important;
  position: relative !important;
  width: 100% !important;
}
.card-2 {
  box-shadow: 0 3px 6px rgba(0, 0, 0, 0.16), 0 3px 6px rgba(0, 0, 0, 0.23);
}
.white-text {
  color: #ffffff !important;
}
.white-bg {
  background: #ffffff !important;
}
.primary-color {
  color: #af0000 !important;
}
#app {
  font-family: "Century Gothic";
  -webkit-font-smoothing: antialiased;
  -moz-osx-font-smoothing: grayscale;
  // text-align: center;
  color: #333;
}

#nav {
  padding: 12px 60px;
  background: #fff;
}

.knowmore {
  font-size: 16px;
  color: #af0000;
  position: relative;
  line-height: 14px;
  margin: 40px 0 0 0;
  text-transform: uppercase;
  cursor: pointer;
}

.knowmore span {
  color: #af0000;
}
a {
  color: #af0000;
  text-decoration: none;
  background-color: transparent;
}
a,
a:hover {
  color: #af0000;
  text-decoration: none;
  border: 0;
  outline: none;
}
.primary {
  background: #af0000 !important;
}
.text-primary {
  color: #af0000 !important;
}
.router-link-exact-active {
  color: #af0000;
}
.tg-parallaximg {
  width: 100%;
  float: left;
  height: 280px;
  overflow: hidden;
  position: relative;
  background: #34495e;
}
.fw-1 {
  font-weight: 100 !important;
}
.fw-2 {
  font-weight: 200 !important;
}
.fw-3 {
  font-weight: 300 !important;
}
.fw-4 {
  font-weight: 400 !important;
}
.fw-5 {
  font-weight: 500 !important;
}
.fw-6 {
  font-weight: 600 !important;
}
.fw-7 {
  font-weight: 700 !important;
}
.fw-8 {
  font-weight: 800 !important;
}
.fw-9 {
  font-weight: 900 !important;
}
.btn-primary {
  background: #af0000 !important;
  color: #fff !important;
  text-transform: capitalize !important;
}
.btn-primary:hover {
  background: #af0000;
  color: #fff !important;
  text-transform: capitalize !important;
}
.btn-secondary {
  background: #ffffff !important;
  color: #af0000 !important;
  text-transform: capitalize !important;
}
.btn-secondary:hover {
  background: #ccc !important;
  color: #af0000 !important;
  text-transform: capitalize !important;
}
.subscribe_now h4 {
  font-size: 30px !important;
  line-height: 44px !important;
  letter-spacing: 2px !important;
  text-transform: uppercase !important;
  color: #34495e !important;
  text-align: center !important;
}
.subscribe_now p {
  font-size: 18px !important;
  line-height: 20px !important;
  letter-spacing: 2px !important;
  color: #34495e !important;
  text-align: center !important;
}
.subscribe_form {
  width: 100% !important;
  margin: 0 auto !important;
  box-shadow: 0px 2px 5px 0px rgba(10, 6, 20, 0.24) !important;
}
.subscribe_form:focus {
  outline: none !important;
}
.subscribe_form .form-control {
  border: none !important;
}
.subscribe_form .form-control:focus {
  box-shadow: none !important;
}
.subscribe_form input {
  height: 66px !important;
  font-size: 25px;
}
.subscribe_form button {
  border: none !important;
  height: 66px !important;
  background-color: #af0000 !important;
  color: #fff !important;
  margin: -1px !important;
  border-radius: 0 !important;
  width: 200px !important;
  font-size: 33px;
  text-transform: uppercase !important;
  position: relative !important;
  transition: all ease 0.3s !important;
  -webkit-transition: all ease 0.3s !important;
  -moz-transition: all ease 0.3s !important;
  -o-transition: all ease 0.3s !important;
  -ms-transition: all ease 0.3s !important;
}
.subscribe_form button:hover,
.subscribe_form button:focus,
.subscribe_form button:active,
.subscribe_form button:visited {
  color: #fff !important;
  background-color: rgba(175, 0, 0, 0.77) !important;
  outline: none !important;
  transition: all ease 0.3s !important;
  -webkit-transition: all ease 0.3s !important;
  -moz-transition: all ease 0.3s !important;
  -o-transition: all ease 0.3s !important;
  -ms-transition: all ease 0.3s !important;
}
.subscribe_form button:hover:before,
.subscribe_form button:focus:before,
.subscribe_form button:active:before,
.subscribe_form button:visited:before {
  background-color: rgba(175, 0, 0, 0.77) !important;
  transition: all ease 0.3s !important;
  -webkit-transition: all ease 0.3s !important;
  -moz-transition: all ease 0.3s !important;
  -o-transition: all ease 0.3s !important;
  -ms-transition: all ease 0.3s !important;
}
.subscribe_form button:before {
  content: "" !important;
  position: absolute !important;
  top: 100% !important;
  left: 0 !important;
  height: 1px !important;
  background-color: #af0000 !important;
  width: 100% !important;
  transition: all ease 0.3s !important;
  -webkit-transition: all ease 0.3s !important;
  -moz-transition: all ease 0.3s !important;
  -o-transition: all ease 0.3s !important;
  -ms-transition: all ease 0.3s !important;
}
.subscribe_form .input-group-btn:last-child > .btn,
.subscribe_form .input-group-btn:last-child > .btn-group {
  z-index: 2 !important;
  margin-left: 0px !important;
}
.service-card-1 {
  // background: #880e4f;
  min-height: 100px;
  padding: 40px;
}
.service-card-2 {
  // background: #00b8d4;
  min-height: 100px;
  padding: 40px;
}
.service-card-3 {
  // background: #263238;
  min-height: 100px;
  padding: 40px;
}
.service-card-title {
  font-size: 30px;
  text-transform: uppercase;
}
.service-card-subtitle {
  font-size: 22px;
  text-transform: uppercase;
}
.purple {
  color: #880e4f;
}
.cyan {
  color: #00b8d4;
}
.blue-grey {
  color: #263238;
}
.orange {
  color: #bf360c;
}
.service-title {
  text-transform: uppercase;
}
.service-title h3 {
  font-size: 40px;
  font-weight: 600;
}
.service-title h5 {
  font-size: 25px;
  font-weight: 100;
}
.pull-right {
  text-align: right !important;
}
.pull-left {
  text-align: left !important;
}
.pull-center {
  text-align: center !important;
}

.btn {
  display: inline-block;
  font-weight: 200;
  color: #212529;
  text-transform: uppercase !important;
  text-align: center;
  vertical-align: middle;
  -webkit-user-select: none;
  -moz-user-select: none;
  -ms-user-select: none;
  user-select: none;
  background-color: transparent;
  border: 1px solid transparent;
  border-top-color: transparent;
  border-right-color: transparent;
  border-bottom-color: transparent;
  border-left-color: transparent;
  border-top-color: transparent;
  border-right-color: transparent;
  border-bottom-color: transparent;
  border-left-color: transparent;
  padding: 4px 8px !important;
  font-size: 15px !important;
  line-height: 1.1rem;
  letter-spacing: 1px;
  border-radius: 50px !important;
  transition: color 0.15s ease-in-out, background-color 0.15s ease-in-out,
    border-color 0.15s ease-in-out, box-shadow 0.15s ease-in-out;
}

.footer-section-title {
  position: relative;
  padding-bottom: 10px;
  font-weight: 100 !important;
  text-align: left !important;
  color: #ffebee;
  margin-bottom: 30px;
}
.footer-section-title + * {
  margin-top: 40px;
}
.footer-section-title:before {
  content: "";
  position: absolute;
  // left: 50%;
  margin-left: 6px;
  width: 70px;
  height: 2px;
  background: #ffebee;
  top: 100%;
}
// .footer-section-title:before,
// .footer-section-title:after {
//   content: "";
//   position: absolute;
//   // left: 50%;
//   margin-left: 6px;
//   width: 45px;
//   height: 1px;
//   background: #ffffff;
//   top: 100%;
// }
// .footer-section-title:after {
//   left: auto;
//   // right: 60%;
//   margin-right: 6px;
// }
// .footer-section-title span:before,
// .footer-section-title span:after {
// content: "";
// position: absolute;
// width: 12px;
// height: 6px;
// border-radius: 50%;
// background: #ffcdd2;
// left: 1%;
// top: 100%;
// margin-top: -2px;
// margin-left: 2px;
// }
// .footer-section-title span:after {
//   // left: auto;
//   right: 50%;
//   margin-left: 0;
//   margin-right: 2px;
// }

.section-title {
  font-family: "Red Rose", cursive;
  position: relative;
  padding-bottom: 10px;
  font-weight: 100 !important;
  text-align: center !important;
  font-weight: 700 !important;
}
.section-title + * {
  margin-top: 40px;
}
.section-title:before,
.section-title:after {
  content: "";
  position: absolute;
  left: 50%;
  margin-left: 6px;
  width: 45px;
  height: 2px;
  background: #af0000;
  top: 100%;
}
.section-title:after {
  left: auto;
  right: 50%;
  margin-right: 6px;
}
.section-title span:before,
.section-title span:after {
  content: "";
  position: absolute;
  width: 6px;
  height: 6px;
  border-radius: 50%;
  background: #af0000;
  left: 50%;
  top: 100%;
  margin-top: -2px;
  margin-left: 2px;
}
.section-title span:after {
  left: auto;
  right: 50%;
  margin-left: 0;
  margin-right: 2px;
}
.spacer {
  width: 100%;
  height: 45px;
}

// .process-flow {
//   background: url(assets/viewcity.jpg) no-repeat center center fixed;
//   -webkit-background-size: cover;
//   -moz-background-size: cover;
//   -o-background-size: cover;
//   background-size: cover;
// }

.gen-header {
  // background: url(assets/newsheader.png) no-repeat;
  background: #fff;
  -webkit-background-size: cover;
  -moz-background-size: cover;
  -o-background-size: cover;
  background-size: cover;
  text-align: center !important;
}

.carousel-control-prev-icon {
  background-image: url("data:image/svg+xml,%3csvg xmlns='http://www.w3.org/2000/svg' fill='%23af0000' width='20' height='20' viewBox='0 0 8 8'%3e%3cpath d='M5.25 0l-4 4 4 4 1.5-1.5L4.25 4l2.5-2.5L5.25 0z'/%3e%3c/svg%3e") !important;
}
.carousel-control-next-icon {
  background-image: url("data:image/svg+xml,%3csvg xmlns='http://www.w3.org/2000/svg' fill='%23af0000' width='20' height='20' viewBox='0 0 8 8'%3e%3cpath d='M2.75 0l-1.5 1.5L3.75 4l-2.5 2.5L2.75 8l4-4-4-4z'/%3e%3c/svg%3e") !important;
}

.carousel-control-next,
.carousel-control-prev {
  position: absolute;
  top: 0;
  bottom: 0;
  z-index: 1;
  display: flex;
  align-items: center;
  justify-content: center;
  width: 15%;
  color: #af0000 !important;
  text-align: center;
  opacity: 0.9 !important;
  transition: opacity 0.15s ease;
}
// .news-header {
//   background: url(assets/newsheader.png) no-repeat;
//   -webkit-background-size: cover;
//   -moz-background-size: cover;
//   -o-background-size: cover;
//   background-size: cover;
// }

.prnt {
  min-height: 200px;
  position: relative;
}

.child {
  width: 90%;
  position: absolute;
  top: 50%;
  left: 50%;
  margin: -25px 0 0 -25px;
  color: #ffffff;
}

.page-title {
  // font-family: "Red Rose", cursive;
  font-size: 33px;
  font-weight: 700;
  text-transform: uppercase;
  color: #af0000;
  padding: 30px 0;
}

.page-breadcrumb {
  font-size: 22px;
  font-weight: 300;
}

.breadcrumb {
  display: flex;
  flex-wrap: wrap;
  padding: 0.75rem 1rem;
  margin-bottom: 1rem;
  list-style: none;
  border-radius: 0.25rem;
  color: #696969 !important;
  background: transparent !important;
}

.breadcrumb a,
a:hover {
  color: #333 !important;
  text-decoration: none;
  border: 0;
  outline: none;
}

.breadcrumb-item.active {
  color: #af0000 !important;
}

.transperent-white {
  background: rgba(255, 255, 255, 0.8);
}
.transperent-black {
  background: rgba(0, 0, 0, 0.5);
}
.carousel-caption {
  // font-family: "Red Rose", cursive;
  position: absolute !important;
  // right: 15% !important;
  bottom: 25% !important;
  left: 60% !important;
  z-index: 10 !important;
  padding-top: 20px !important;
  padding-bottom: 20px !important;
  color: #af0000 !important;
  text-align: center !important;
  // background: rgba(0, 0, 0, 0.75) !important;
  letter-spacing: 2px;
  width: 33% !important;
}

.carousel-caption h3 {
  // font-size: 50px !important;
  font-size: 3.3vw;
  font-weight: 600;
  text-transform: uppercase !important;
}
.carousel-caption p {
  // font-size: 22px !important;
  font-size: 2vw;
  letter-spacing: 1px;
  color: #636363 !important;
  font-weight: 200 !important;
}

.page-subtitle {
  color: #fff;
}

.dropdown-item:hover {
  color: #ffffff !important;
  background-color: #af0000 !important;
}
.carousel-control-next,
.carousel-control-prev {
  position: absolute;
  top: 0;
  bottom: 0;
  z-index: 1;
  display: flex;
  align-items: center;
  justify-content: center;
  width: 15%;
  color: rgba(175, 0, 0, 0.27);
  text-align: center;
  opacity: 0.5;
  transition: opacity 0.15s ease;
}

.btn-primary {
  background: #af0000 !important;
  color: #fff !important;
  text-transform: capitalize !important;
}
.btn-primary {
  color: #fff;
  background-color: #af0000;
  border-color: #af0000;
}
.btn-secondary {
  background: #fff !important;
  color: #af0000 !important;
  text-transform: capitalize !important;
}
.btn-secondary {
  color: #af0000;
  background-color: #fff;
  border-color: #fff;
}
.btn {
  display: inline-block;
  font-weight: 200;
  color: #212529;
  text-transform: uppercase !important;
  text-align: center;
  vertical-align: middle;
  -webkit-user-select: none;
  -moz-user-select: none;
  -ms-user-select: none;
  user-select: none;
  background-color: transparent;
  border: 1px solid transparent;
  border-top-color: transparent;
  border-right-color: transparent;
  border-bottom-color: transparent;
  border-left-color: transparent;
  padding: 8px 16px;
  font-size: 1.35rem;
  line-height: 1.8rem;
  letter-spacing: 1px;
  border-radius: 0.25rem;
  transition: color 0.15s ease-in-out, background-color 0.15s ease-in-out,
    border-color 0.15s ease-in-out, box-shadow 0.15s ease-in-out;
}
.btn:hover {
  text-transform: capitalize !important;
}
.btn-primary:hover {
  text-transform: capitalize !important;
}
.btn-secondary:hover {
  text-transform: capitalize !important;
}
.card-header {
  background: #ffffff !important;
  margin-bottom: 30px !important;
  border-bottom: none !important;
}
.card-footer {
  background: #ffffff !important;
  margin-top: 30px !important;
  border-top: none !important;
}

.default-two-col .content-column h2 {
  font-size: 18px;
  text-transform: capitalize;
  margin-bottom: 20px;
  font-weight: 700;
  text-transform: uppercase;
  color: #1b1b1b;
}
.sec-title h2,
h2.styled-title {
  position: relative;
  font-size: 18px;
  color: #2b2b2b;
  text-transform: uppercase;
  font-weight: 700;
  padding-left: 34px;
}
h1,
h2,
h3,
h4,
h5,
h6 {
  position: relative;
  font-family: "Raleway", sans-serif;
  font-weight: normal;
  margin: 0px;
  margin-bottom: 0px;
  background: none;
  line-height: 1.8em;
}

p {
  text-align: justify !important;
}

.sec-title h2::before,
h2.styled-title::before {
  content: "";
  position: absolute;
  left: 0px;
  top: 4px;
  width: 15px;
  height: 20px;
  background: #ac1410;
}
::after,
::before {
  -webkit-box-sizing: border-box;
  -moz-box-sizing: border-box;
  box-sizing: border-box;
}

.sec-title h2::after,
h2.styled-title::after {
  content: "";
  position: absolute;
  left: 10px;
  top: 4px;
  width: 10px;
  height: 20px;
  background: #c9262d;
  transform: skewX(-25deg);
  -webkit-transform: skewX(-25deg);
  -ms-transform: skewX(-25deg);
  -o-transform: skewX(-25deg);
  -moz-transform: skewX(-25deg);
}
::after,
::before {
  -webkit-box-sizing: border-box;
  -moz-box-sizing: border-box;
  box-sizing: border-box;
}
.default-two-col .content-column .text {
  text-align: justify;
}
.mb {
  margin-bottom: 50px;
  padding: 0 35px 0 0;
}
</style>
